import React from "react";
import { Link } from "react-router-dom";

const Button = ({
  className = "",
  onClick,
  type,
  variant = "primary",
  fullWidth = false,
  to = null,
  as = "link",
  disabled,
  children,
  ...rest
}) => {
  const baseStyles = `inline-flex items-center justify-center rounded-full text-md font-bold text-center tracking-wide py-3 px-4 transition-all duration-300 ease-in-out min-w-[140px] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary disabled:cursor-not-allowed ${
    fullWidth ? "w-full" : ""
  }`;

  const variantClasses = {
    primary: `${baseStyles} bg-primary text-white hover:bg-[#d1006d] disabled:bg-[#ff99ce] ${className}`,
    secondary: `${baseStyles} bg-white text-primary border-2 border-primary hover:text-[#d1006d] hover:border-[#d1006d] disabled:opactiy-50 ${className}`,
    tertiary: `${baseStyles} bg-[#afb6b9] hover:bg-[#858f93] disabled:opactiy-50 text-white`,
  };

  const handleOnClick = (event) => {
    if (disabled) {
      event.preventDefault();
      return;
    }
    if (onClick) {
      onClick(event);
    }
  };

  return to ? (
    as === "anchor" ? (
      <a href={to} className={variantClasses[variant]} {...rest}>
        {children}
      </a>
    ) : (
      <Link
        to={to}
        className={`${
          disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"
        } ${variantClasses[variant]}`}
        onClick={handleOnClick}
        {...rest}
      >
        {children}
      </Link>
    )
  ) : (
    <button
      className={variantClasses[variant]}
      onClick={onClick}
      type={type}
      disabled={disabled}
      {...rest}
    >
      {children}
    </button>
  );
};

export default Button;
